//time constants in milliseconds
export const FIFTY_MS = 50
export const HUNDRED_MS = 100
export const TEN_SECONDS_MS = 10000
